import React from "react";
import { dayjs } from "../../../../Utilities/dayjs";
import {
  Button,
  Col,
  Divider,
  Drawer,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Tooltip,
  Upload,
} from "antd";
import {
  CloseOutlined,
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useClient } from "../../../Context/ClientContext";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import ChartofAccountServicesNew from "../../../Services/ChartofAccountServicesNew";
import LedgerService, {
  SearchLedgerByGroupsTypes,
} from "../../../Services/LedgerService";
import AddGroup from "../../Master/Group/AddGroup";
import { BankAccountTypes } from "../../../Services/ClientService";
import EntryLevelKeys from "../../../Common/EntryLevelKeys";
import DocumentPreview from "../../../Common/DocumentPreview";
import { findUserOnlyOnePremission } from "../../Users/Roles/UserSecurityFind";
import { useUser } from "../../../../Context/UserContext";
import { useHotkey } from "../../../Context/HotKeyContext";

const AddBankAccountModel: React.FC<{
  open: boolean;
  onCancel: any;
  bankAccountTrigger?: (param: any) => void;
  curentBankAccountId?: any;
  id?: any;
  setNewItem?: React.Dispatch<React.SetStateAction<any>>;
  // triggerBankAccountDetails?: any;
  type?: string;
  allBankAccount?: any;
  defaultGroup?: any;
}> = (props) => {
  // console.log(props.allBankAccount, "props");
  const { showKeys } = useHotkey();
  const [form] = Form.useForm();
  const { currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  const autoCompleteRef = React.useRef<any>(null);

  const { openNotification } = React.useContext(notificationContext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [modelLoading, setModelLoading] = React.useState<boolean>(false);
  const [openModel, setOpenModel] = React.useState<{
    open: boolean;
    param: any;
  }>({
    open: false,
    param: "",
  });
  const [groupData, setGroupData] = React.useState<any[]>([]);
  const [ccViewDetails, setCCViewDetails] = React.useState<boolean>(false);
  const [bankViewDetails, setBankViewDetails] = React.useState<boolean>(false);
  const [trigger, setTrigger] = React.useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [editRefresh, setEditRefresh] = React.useState<{
    displayName: string;
    openingBalance: number;
  }>({ displayName: "", openingBalance: 0 });
  const [saveButtonLoading, setSaveButtonLoading] =
    React.useState<boolean>(false);
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const [groupList, setGropList] = React?.useState<any>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = React.useState<boolean>(false);
  const [bankTypeValue, setBankTypeValue] = React.useState<BankAccountTypes>(
    BankAccountTypes.CurrentAccount
  );
  const [deleteUploadId, setDeleteUploadId] = React.useState<string[]>([]);
  const [previewImage, setPreviewImage] = React.useState<{
    isBaseConvert: boolean;
    path: any;
  }>({ isBaseConvert: false, path: "" });

  const [groupDropdownLoading, setGroupDropdownLoading] =
    React.useState<boolean>(false);
  // const [type, setType] = React.useState<InventoryType>(
  //   props.id ? InventoryType.Update : InventoryType.Duplicate
  // );

  // Post Bank Account Api

  // console.log(editRefresh);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current.focus();
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  // --------- InitialValues in Add Bank Account Model ---------
  const initialValues = {
    bankAccountType: 1,
    date: dayjs(),
  };

  // const getGroupLabel = (value: any) => {
  //   const group = groupList?.find((group: any) => group?.value === value);
  //   return group ? group?.label : value;
  // };

  React?.useEffect(() => {
    getGroupList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  const getGroupList = async () => {
    setGroupDropdownLoading(true);
    let res = await ChartofAccountServicesNew?.getGroupList(
      currentClient?.id!,
      currentClient?.productModule,
      "",
      "",
      "",
      "",
      SearchLedgerByGroupsTypes?.BankAndCash
    );
    if (res?.items?.length > 0) {
      console.log("res", res.items);

      const dataSetInApi = (allgroupList: any[]) => {
        let result: any[] = [];
        allgroupList.forEach((x: any) => {
          const node: any = {
            label: x?.group_Name,
            value: x?.id,
            title: x?.group_Name.length > 25 ? x?.group_Name : "",
            // title: x?.parent,
          };
          // console.log("index........................", node);
          result.push(node);
          if (x?.children?.length > 0) {
            result = result.concat(dataSetInApi(x?.children));
          }
        });
        return result;
      };

      const flattenedData = dataSetInApi(res?.items);
      console.log("flattenedData", flattenedData);
      setGropList(flattenedData);
      setGroupDropdownLoading(false);
    }
  };

  React.useEffect(() => {
    setLoading(true);
    setModelLoading(true);
    const getListData = async () => {
      await ChartofAccountServicesNew.getGroupList(
        currentClient?.id!,
        currentClient?.productModule
      )
        .then((res: any) => {
          if (res.items) {
            setGroupData(res.items);
            //  if (props.editData.id) {
            //    setGroupType(props.editData?.group_Type);
            //    form.setFieldsValue(props.editData);
            //  }
          } else {
            setGroupData([]);
            console.log("Error", res);
          }
          setLoading(false);
          setModelLoading(false);
        })
        .catch((err: any) => {
          console.log("Error", err);
          setLoading(false);
          setModelLoading(false);
        });
      //  setTotalRecords(res?.totalRecords);
    };
    getListData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  React.useEffect(() => {
    if (props?.id && groupData?.length > 0) {
      setLoading(true);
      const editBankAccount = props.allBankAccount?.find(
        (x: any) => x.id === props?.id
      );
      console.log("editBankAccount", editBankAccount);

      findParentGroup(editBankAccount?.parent);
      setBankTypeValue(
        editBankAccount?.bankDetail?.accountType === 0
          ? undefined
          : editBankAccount?.bankDetail?.accountType
      );
      form.setFieldsValue({
        ...editBankAccount,
        parent: editBankAccount?.parent,
        bankDetail: editBankAccount?.bankDetail
          ? {
              ...editBankAccount?.bankDetail,
              accountType:
                editBankAccount?.bankDetail?.accountType === 0
                  ? undefined
                  : editBankAccount?.bankDetail?.accountType,
            }
          : [{}],
      });

      setModelLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.id, groupData]);

  const findParentGroup = (parent: string, defaultGroupName?: string) => {
    console.log("parent", parent, defaultGroupName, "defaultGroupName");
    setBankViewDetails(false);
    var x = groupData.find((x) => x.id === parent);
    console.log("findgroup....", x);
    if (
      !x?.editable ||
      defaultGroupName === "Bank Account" ||
      defaultGroupName === "Bank OD A/c"
    ) {
      if (
        x?.group_Name === "Bank Account" ||
        defaultGroupName === "Bank Account" ||
        defaultGroupName === "Bank OD A/c"
      ) {
        setBankViewDetails(true);
        if (ccViewDetails) {
          form.setFieldValue(["bankDetail", "accountType"], "");
        }
        setCCViewDetails(false);
      } else if (
        x?.group_Name === "Bank Account (Short Term Borrowings)" ||
        defaultGroupName === "Short-term Borrowings" ||
        defaultGroupName === "Bank Account (Short Term Borrowings)"
      ) {
        setBankViewDetails(true);
        if (!ccViewDetails) {
          form.setFieldValue(["bankDetail", "accountType"], "");
        }
        setCCViewDetails(true);
      } else {
        setBankViewDetails(false);
        form.setFieldValue(["bankDetail", "accountType"], "");
        setCCViewDetails(false);
      }
    } else {
      findParentGroup(x?.parent);
    }
  };

  const saveLedger = () => {
    form.validateFields().then(async (value) => {
      console.log("post Data....", value);
      setSaveButtonLoading(true);
      setModelLoading(true);
      let data = {
        ...value,
        bankDetail: new Array(value?.bankDetail),
        gstRate: {
          rate: value?.gstRate?.title ?? value?.gstRate,
          id: value?.gstRate?.value,
          name: value?.gstRate?.label,
        },
        parent: value?.parent?.value ?? value?.parent,
        order: value?.order ?? 1000,
        //  contactInformation: value?.contactInformation?.map(
        //    (index: any, i: number) => {
        //      console.log(checkbox);
        //      if (i === checkbox) {
        //        return Object.assign(index, { isDefault: true });
        //      } else if (i !== checkbox) {
        //        return Object.assign(index, { isDefault: false });
        //      }
        //    }
        //  ),
        system: false,
        isActive: true,
        isAudited: false,
        editable: true,
        deleteUploadId: deleteUploadId,
      };

      await LedgerService.postLedger(currentClient?.id!, data, props?.id)
        .then((res: any) => {
          if (res.result) {
            // setProps1(true);
            props.bankAccountTrigger &&
              props.bankAccountTrigger((x: boolean) => !x);
            // props?.setRefresh((x: boolean) => !x);
            props?.setNewItem && props?.setNewItem(res.result);
            props.onCancel(false);
            setModelLoading(false);
            openNotification(
              "success",
              `Bank account ${
                props?.id ? "updated successfully." : "added successfully"
              }`
            );
            //  props.setOpenDrawer({});
          } else if (res?.message) {
            openNotification("error", res?.message);
            setModelLoading(false);
          }
          setSaveButtonLoading(false);
        })
        .catch((ex: any) => {
          console.error(ex);
          openNotification("error", ex?.message);
          setSaveButtonLoading(false);
          setModelLoading(false);
        });
    });
  };

  EntryLevelKeys({
    save: () => saveLedger(),
    cancel: () => props.onCancel(false),
  });

  // const getDetailsbyId = async () => {
  //   let res = await LedgerService?.getLedgerDetails(
  //     currentClient!.id,
  //     props?.id
  //   );
  //   if (res?.result) {
  //     console.log();

  //      findParentGroup(res.result?.parent);
  //     // setSelectedIndex(res?.result?.parent);
  //     form?.setFieldsValue({
  //       ledgerName: res?.result?.ledgerName,
  //       aliasName: res?.result?.aliasName,
  //       order: res?.result?.order,
  //       balance: res?.result?.balance,
  //       parent: res?.result?.parent,
  //       bankDetail:
  //         res?.result?.bankDetail?.length > 0 && res?.result?.bankDetail[0],
  //     });
  //   } else {
  //     console.error("error..", res.errors);
  //   }
  // };

  // console.log("----", selectedIndex);

  const permissionCashAdd = findUserOnlyOnePremission(
    "Master.Ledger.Cash.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionBankAdd = findUserOnlyOnePremission(
    "Master.Ledger.Bank.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  return (
    <div>
      <Drawer
        open={props.open}
        title={
          <Row>
            <Col sm={15} xs={23} style={{ fontSize: "17px" }}>
              {!props?.id
                ? "Add Bank/Cash Account"
                : "Update Bank/Cash Account"}
            </Col>
            <Col sm={11} xs={12}>
              {/* <Checkbox
                disabled
                checked={primaryAccount}
                onChange={(e: any) => {
                  setPrimaryAccount(e.target.checked);

                }}
              >
                Primary account
              </Checkbox> */}
            </Col>
          </Row>
        }
        width={"500px"}
        onClose={() => props.onCancel()}
        // closable={props.onCancel}
        maskClosable={false}
        // centered
        closable={false}
        extra={
          <Space>
            <CloseOutlined onClick={() => props.onCancel()} />
          </Space>
        }
        footer={
          <div style={{ textAlign: "right" }}>
            <>
              <Tooltip title={<p>ALT+C</p>} placement="topLeft" open={showKeys}>
                <Button
                  onClick={() => {
                    form.resetFields();
                    props.onCancel();
                  }}
                >
                  Cancel
                </Button>
              </Tooltip>
            </>

            <>
              <Tooltip title={<p>ALT+S</p>} placement="topLeft" open={showKeys}>
                <Button
                  type="primary"
                  onClick={() => saveLedger()}
                  loading={saveButtonLoading}
                  className="modelSaveButtonMargin"
                >
                  {!props?.id ? "Add" : "Update"}
                </Button>
              </Tooltip>
            </>
          </div>
        }
      >
        <Spin indicator={antIcon} spinning={modelLoading}>
          <Form
            form={form}
            name="item"
            autoCapitalize="false"
            requiredMark={true}
            initialValues={initialValues}
            colon={false}
            labelAlign="left"
            labelWrap={true}
            layout="vertical"
          >
            <Spin indicator={antIcon} spinning={modelLoading}>
              <Row
                // style={{ justifyContent: "space-between" }}
                gutter={{ sm: 14 }}
              >
                <Col sm={12} xs={24}>
                  <Form.Item
                    name="ledgerName"
                    label="Bank Account Name"
                    rules={[
                      {
                        required: true,
                        message:
                          "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
                        pattern: /^[A-Za-z][ A-Za-z0-9_()&-.]*$/,
                      },
                      {
                        min: 3,
                        max: 80,
                        message:
                          "Length must be Minimum 3 or Maximum 80 characters long",
                      },
                    ]}
                    className="input-item"
                  >
                    <Input ref={autoCompleteRef} />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24}>
                  <Form.Item
                    label="Alias/Short Name"
                    name="aliasName"
                    className="input-item"
                    rules={[
                      {
                        min: 3,
                        max: 20,
                        message:
                          "Length must be Minimum 3 or Maximum 80 characters long",
                      },
                      {
                        pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
                        message:
                          "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
                      },
                    ]}
                  >
                    <Input minLength={3} maxLength={20} />
                  </Form.Item>
                </Col>

                {/* <Col sm={12} xs={24}>
                  <Form.Item name="order" label="Order" className="input-item">
                    <Input />
                  </Form.Item>
                </Col> */}

                <Col sm={12} xs={24}>
                  <Form.Item
                    label="Bank Group"
                    name="parent"
                    className="input-item"
                    style={{ width: "100%" }}
                    rules={[
                      { required: true, message: "Account group is required" },
                    ]}
                  >
                    <Select
                      labelInValue
                      options={groupList}
                      // onChange={handleParentGroupChange}
                      loading={groupDropdownLoading}
                      onChange={(e) => findParentGroup(e.value, e.label)}
                      dropdownRender={(customerOptions) => (
                        <>
                          {customerOptions}
                          {(permissionCashAdd || permissionBankAdd) && (
                            <>
                              <Divider style={{ margin: "5px 0px" }} />
                              <Button
                                style={{ width: "100%" }}
                                icon={<PlusOutlined />}
                                type="link"
                                onClick={() =>
                                  setOpenModel({ open: true, param: "" })
                                }
                              >
                                New Group
                              </Button>
                            </>
                          )}
                        </>
                      )}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <>
                {(bankViewDetails || ccViewDetails) && (
                  <>
                    <Divider
                      orientation="left"
                      orientationMargin="0"
                      className="dividertext"
                      style={{ marginTop: "11px", marginBottom: "11px" }}
                    >
                      <p style={{ fontWeight: 600 }}>Bank Details</p>
                    </Divider>
                    <Row
                      style={{ justifyContent: "space-between" }}
                      gutter={{ sm: 14 }}
                    >
                      <Col sm={12} xs={24}>
                        <Form.Item
                          name={["bankDetail", "accountHolderName"]}
                          label="Holder Name"
                          rules={[
                            {
                              // required: true,
                              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.]*$/,
                              message: "Enter valid account holder's name",
                            },
                          ]}
                          className="input-item"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col sm={12} xs={24}>
                        <Form.Item
                          label="Account Number"
                          name={["bankDetail", "accountNumber"]}
                          className="input-item"
                          rules={[
                            {
                              pattern: new RegExp(/^(?!0+$)\d{6,18}$/),
                              message:
                                "Enter valid account number in digits with minimum 6 and maximum 18 length",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col sm={12} xs={24}>
                        <Form.Item
                          name={["bankDetail", "accountType"]}
                          label="Account Type"
                          className="input-item"
                          rules={[
                            {
                              required: true,
                              message: "Selection of account type is required",
                            },
                          ]}
                        >
                          <Select
                            onChange={(val) => {
                              console.log(
                                "bank detail",
                                form.getFieldValue([
                                  "bankDetail",
                                  "accountType",
                                ])
                              );
                              setBankTypeValue(val);
                            }}
                            options={
                              ccViewDetails
                                ? [
                                    {
                                      label: "Cash Credit Account",
                                      value: BankAccountTypes.CashCreditAccount,
                                      title: "",
                                    },
                                    {
                                      label: "Overdraft Account",
                                      value: BankAccountTypes.OverdraftAccount,
                                      title: "",
                                    },
                                    {
                                      label: "Credit Card Account",
                                      value: BankAccountTypes.CreditCard,
                                      title: "",
                                    },
                                  ]
                                : [
                                    {
                                      label: "Saving Account",
                                      value: BankAccountTypes.SavingAccount,
                                      title: "",
                                    },
                                    {
                                      label: "Current Account",
                                      value: BankAccountTypes.CurrentAccount,
                                      title: "",
                                    },
                                  ]
                            }
                            // style={{
                            //   width: window.innerWidth <= 425 ? "226px" : " ",
                            // }}
                          />
                        </Form.Item>
                      </Col>

                      <Col sm={12} xs={24}>
                        <Form.Item
                          label="Bank Name"
                          name={["bankDetail", "bankName"]}
                          className="input-item"
                          rules={[
                            {
                              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.]*$/,
                              message: "Enter valid bank's name",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col sm={12} xs={24}>
                        <Form.Item
                          label="IFSC Code"
                          name={["bankDetail", "ifsCode"]}
                          className="input-item"
                          style={{ width: "100%" }}
                          rules={[
                            {
                              pattern: /^[A-Za-z]{4}[0][A-Za-z0-9]{6}$/,
                              message: "Input valid IFSC code ",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col sm={12} xs={24}>
                        <Form.Item
                          label="Branch"
                          name={["bankDetail", "branch"]}
                          className="input-item"
                          style={{ width: "100%" }}
                          rules={[
                            {
                              pattern: /^[A-Za-z][ A-Za-z]*$/,
                              message: "Enter valid branch's name",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      {/* {bankTypeValue === BankAccountTypes.CurrentAccount ||
                        bankTypeValue === BankAccountTypes.CashCreditAccount ||
                        (bankTypeValue ===
                          BankAccountTypes.OverdraftAccount && (
                          <Col sm={12} xs={24}>
                            <Form.Item
                              label="OD Limit"
                              name={["bankDetail", "odLimit"]}
                              className="input-item"
                            >
                              <InputNumber
                                min={0}
                                style={{ width: "100%" }}
                                controls={false}
                              />
                            </Form.Item>
                          </Col>
                        ))} */}
                      <Col sm={12} xs={24}>
                        <Form.Item
                          label="UPI Id"
                          name={["bankDetail", "upiId"]}
                          className="input-item"
                          style={{ width: "100%" }}
                          rules={[
                            {
                              pattern:
                                /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/,
                              message: "Please enter a valid UPI Id",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      {(bankTypeValue === BankAccountTypes.CashCreditAccount ||
                        bankTypeValue === BankAccountTypes.CreditCard ||
                        bankTypeValue ===
                          BankAccountTypes.OverdraftAccount) && (
                        <Col sm={12} xs={24}>
                          <Form.Item
                            name={["bankDetail", "odLimit"]}
                            label={
                              bankTypeValue ===
                              BankAccountTypes.CashCreditAccount
                                ? "CC Limit"
                                : bankTypeValue === BankAccountTypes.CreditCard
                                ? "Credit Limit"
                                : "Over Draft Limit"
                            }
                            className="input-item"
                          >
                            <InputNumber
                              controls={false}
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </>
                )}
              </>
              <Divider
                orientation="left"
                orientationMargin="0"
                className="dividertext"
                style={{ marginTop: "11px", marginBottom: "11px" }}
              >
                <p style={{ fontWeight: 600 }}>Upload</p>
              </Divider>
              <Row>
                <Col sm={12} xs={24}>
                  <Form.Item
                    name="attachments"
                    valuePropName="fileList"
                    className="input-item"
                    getValueFromEvent={(e) => {
                      return e.fileList;
                    }}
                    // className="m-0"
                  >
                    <Upload
                      // multiple
                      maxCount={5}
                      accept={".png, .jpg, .jpeg, .pdf"}
                      // accept={".png, .jpg, .jpeg"}
                      beforeUpload={() => {
                        return false;
                      }}
                      onRemove={(e: any) => {
                        if (props?.id && e?.id) {
                          setDeleteUploadId([...deleteUploadId, e?.id]);
                        }
                      }}
                      onPreview={(e: any) => {
                        console.log("preview", e);
                        if (props?.id && e?.path) {
                          setPreviewImage({
                            isBaseConvert: false,
                            path: e,
                          });
                        } else if (e.type?.split("/")[0] === "image") {
                          setPreviewImage({
                            isBaseConvert: true,
                            path: e,
                          });
                        }
                      }}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        style={{ backgroundColor: "ButtonFace" }}
                      >
                        Upload
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </Spin>
          </Form>
        </Spin>
      </Drawer>
      {openModel.open && (
        <AddGroup
          open={openModel.open}
          editData={openModel?.param}
          onCancel={() => setOpenModel({ open: false, param: "" })}
          setTrigger={() => setTrigger(!trigger)}
          groupData={groupData}
          type={SearchLedgerByGroupsTypes.BankAndCash}
        />
      )}
      {previewImage.path && (
        <DocumentPreview
          open={true}
          onCancel={() =>
            setPreviewImage({
              path: "",
              isBaseConvert: false,
            })
          }
          documentDetails={previewImage}
        />
      )}
    </div>
  );
};

export default AddBankAccountModel;
